module.exports = require('./dist/ReactCrop');


//////////////////
// WEBPACK FOOTER
// ./~/react-image-crop/index.js
// module id = 466
// module chunks = 1 2